import { SerpLendingDelaySnapshot } from '@/components/Approval/@components/SerpLendingDelay';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 163 SERP 여신유예신청 — 저장 content 그대로(레거시 조회와 동일) */
const SerpLendingDelaySlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpLendingDelaySnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpLendingDelaySlot;
